import ReducePermissions from './permissions/utils/reducePermissions';
import Resolvers from './permissions/resolvers/userPermissionResolvers';
import USER_PERMISSIONS from '../../permissions/user.permissions';

export default (user, permissions) => ReducePermissions({
  permissionKeys: USER_PERMISSIONS,
  createResolvers: Resolvers,
  sources: { user, permissions },
});
